import { Injectable } from '@angular/core';
import { DevwareMetaData, DwAppPermissionEntity, DwAppPermissionMetaData, DwContextDefinition, DwCustomContextBase, DwCustomContextDefinition, DwOrmDataService, DwQuery, DwQueryHelper, DwSecurityTopics, DwSecurityUserService } from '@devwareapps/devware-cap';
import { AppMetaData, AppMetaDataItemNames } from '../../../../meta-data/app-meta-data.service';
import { AdminManagerService } from '../../services/admin-manager.service';

export const CurrentSchoolContext= 'currentSchoolContext';
@DwCustomContextDefinition({
    keyName: CurrentSchoolContext,
    display: 'Current School Context',
    isGlobal: true,
})
@Injectable()
export class CurrentSchoolContextService extends DwCustomContextBase {

    constructor(private dwSecurityUserService: DwSecurityUserService,
        private adminManagerService: AdminManagerService
        
        ) {
        super();
    }

    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.buildQueryFunction = (context) => this.buildQuery(context);

        contextDef.item = AppMetaDataItemNames.FlightSchoolOrganization;
        //contextDef.metaDataQueryId = 1019;

        contextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];

        contextDef.cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaData.FlightSchoolOrganization.ItemDetail.itemName));
        contextDef.cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaData.DwUser.ItemDetail.itemName));
    }

    buildQuery(resolvedContext: any): DwQuery {
        const query = AppMetaData.FlightSchoolOrganization.CreateQueryBuilder();

        if (!this.dwSecurityUserService.securityContext?.ApplicationUser) {
            return null;
        }
   
        query.query.FieldSettings.LoadAllLookupDisplayFields = true;

        const pilexosUser = this.adminManagerService.getPilexosUser();
        
        query.addFilterAnd(filters => filters.Equal(f => f.FlightSchoolOrganizationId, pilexosUser.flightSchoolOrganizationId || -1));

        return query.query;

    }


}
